module.exports = __webpack_public_path__ + "static/_01-a4cb492eee21a5fb3b915cc4fdc451bc.png";